import moment from 'moment';

const validTimeFormats = ['HH:mm', 'H:mm'];

export default function hourValid(hour) {
  return moment(hour, validTimeFormats, true).isValid();
}
